/**
 * Вкладка «Площадки» окна товара: идентификаторы на площадках, полная матрица
 * «площадка × кабинет» и ниже — связи сущностей (бывшая вкладка «Связи»).
 */

import React from 'react'
import { EntityRelationsPanel } from '../../../entity-relations'
import type { PresenceData } from '../../presence'
import type { ProductPresenceEntry, ProductV2 } from '../../types'
import { ProductPresencePanel } from '../ProductPresencePanel'
import { SectionTitle } from './parts'

interface PlacesTabProps {
  product: ProductV2
  presence: PresenceData
  onOpenEntry?: (entry: ProductPresenceEntry) => void
}

export const PlacesTab: React.FC<PlacesTabProps> = ({ product, presence, onOpenEntry }) => {
  return (
    <div className="space-y-5">
      <section>
        <SectionTitle>Карточки в кабинетах</SectionTitle>
        <ProductPresencePanel article={product.article} data={presence} onOpenEntry={onOpenEntry} />
      </section>

      <section>
        <SectionTitle>Связи сущностей</SectionTitle>
        <EntityRelationsPanel article={product.article} current={{ kind: 'product', id: product.article }} />
      </section>
    </div>
  )
}
